import { Action, initialState, State } from "store/store";

export const updateScormSettings = (
  state: State = initialState,
  { data }: Action
): State => {
  const nextState = {
    ...state,
    scormSettings: {
      ...(state as any).scormSettings,
      ...data,
    },
  };

  return nextState;
};